import { parse, parseUrl, stringify } from 'query-string';

const stringifyUrl = (url, object, options) => {
  const qs = stringify(object, options);
  if (qs.length > 0) {
    return `${url}?${qs}`;
  }

  return url;
};

const queryString = {
  parse: value => {
    return parse(value);
  },

  parseUrl: value => {
    return parseUrl(value);
  },

  stringify: (object, options) => {
    return stringify(object, options) ?? '';
  },

  stringifyUrl,

  addParams: (url, params = {}, options) => {
    const { url: baseUrl, query } = parseUrl(url);
    return stringifyUrl(baseUrl, { ...query, ...params }, options);
  },
};

export default queryString;
